(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-no-group"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-fit-guide"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function (event) {
    var navItems = document.querySelectorAll('.fit-guide__menu li a');

    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var ihref = item.getAttribute('href');
        document.querySelector(`[id="${ihref}"]`).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });

    /* Mobile nav */
    var mobileNav = document.querySelector('#frame-options');
    mobileNav.onchange = function () {
      var selectedOption = this.value;
      if (selectedOption != -0) {
        var fitGuides = document.querySelectorAll('.fit-guide__guide');
        var fitGuideActive = document.querySelector('.fit-guide__guide.active');
        var selectElement = document.querySelector(`[id="#${selectedOption}"]`);

        fitGuideActive.classList.remove('active');
        selectElement.classList.add('active');
        window.location.hash = selectedOption;
      }
    };
  });

  } catch(e) { console.error(e); }
})();
})();
